export function redirectToOrigin() {
  if (window.location.pathname !== "/") {
    window.location.href = window.location.origin;
  }
}

export const navigateToAdditionalWalletsPage = (temporalAccessToken: string) => {
  window.open(`${process.env.VITE_ADDITIONAL_WALLET_PAGE}/${temporalAccessToken}`, "_blank");
};

export const isLinkActive = (isActive: boolean, to: string) => {
  if (to === "/") {
    if (window.location.pathname === "/") return true;

    return /^\/x\/[^/]+\/?$/.test(window.location.pathname);
  }
  return isActive;
};
